import { useState } from "react";
import { Button, Form, Input, notification, Select } from "antd";
import { useNavigate } from "react-router-dom";
import { post } from "../../../services";

const EventForm = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  // notification handler
  const openNotification = (message, description) => {
    notification.open({
      message: message,
      description: description,
    });
  };

  // onFinish handler
  const onFinish = (values) => {
    setLoader(true);
    post(`/auth/register`, { ...values })
      .then(() => {
        setLoader(false);
        navigate("/admin");
        openNotification("Success", "Admin created Successfully");
      })
      .catch(() => {
        setLoader(false);
        openNotification("Error", "");
      });
  };

  return (
    <>
      <div className="header">
        <h3>Add Admin</h3>
      </div>
      <div className="form_container">
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: "Please enter your Name" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="email"
            label="Email"
            rules={[{ required: true, message: "Please enter your Email" }]}
          >
            <Input type="email" />
          </Form.Item>
          <Form.Item
            name="role"
            label="Role"
            rules={[{ required: true, message: "Please select role" }]}
          >
            <Select
              options={[
                { value: "", label: "Select Role" },
                { value: "admin", label: "Admin" },
                { value: "sub-admin", label: "Sub Admin (Limited Access)" },
                { value: "event_operator", label: "Event Manager" },
              ]}
            />
          </Form.Item>
          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: "Please enter your Password" }]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item>
            <div className="form_submit">
              <Button
                className="back_button"
                onClick={() => navigate("/admins")}
              >
                Back
              </Button>
              <Button htmlType="submit">{loader ? "wait..." : "Save"}</Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};
export default EventForm;
